<template>
  <div class="reports">
    <div v-if="$store.state.pageLoaded" class="reports-listing">

      <div v-if="$store.state.receivedData.performancesSimple.list.length > 0">
      <md-table>
        <md-table-row>
          <md-table-head>Predstava</md-table-head>
          <md-table-head>Datum</md-table-head>
          <md-table-head>Vrijeme</md-table-head>
          <md-table-head class="t-align-center">Akcije</md-table-head>
        </md-table-row>
        <md-table-row v-for="performance in $store.state.receivedData.performancesSimple.list">
          <md-table-cell>{{ performance.play_title }}</md-table-cell>
          <md-table-cell>{{ performance.performance_date }}</md-table-cell>
          <md-table-cell>{{ performance.performance_time }}</md-table-cell>
          <md-table-cell class="actions-cell t-align-center">
            <md-button class="md-dense md-primary md-raised" v-on:click="showReport(performance)">Vidi izvješće</md-button>
            </md-table-cell>
        </md-table-row>
      </md-table>
       <md-dialog :md-active.sync="reportVisible" class="md-scrollbar dialog-container report-dialog">
          <md-dialog-title>Prodaja</md-dialog-title>
          <md-button class="md-icon-button md-raised md-accent back-button" title="Natrag" v-on:click="reportVisible = false">
            <md-icon>keyboard_arrow_left</md-icon>
          </md-button>
          <div ref="reports" class="print-wrapper">
            <h2 class="md-title">
              Specifikacija blagajne po predstavi
              <span class="lighter">Sezona 2020./2021.</span>
            </h2>
            <table class="description print-table">
              <tr>
                <td>
                  <strong>Predstava: </strong>
                  {{ selectedPerformance.play_title }}
                </td>
                <td>
                  <strong>Datum: </strong>
                  {{ selectedPerformance.performance_date }}
                </td>
                <td>
                  <strong>Vrijeme: </strong>
                  {{ selectedPerformance.performance_time }}
                </td>
              </tr>
            </table>
            <md-table v-if="reportVisible && $store.state.selectedObject['status|kind'] !== undefined" class="print-table">
              <md-table-row>
                <md-table-head>Pozicija</md-table-head>
                <md-table-head v-for="status in statuses">
                  {{ status }}
                </md-table-head>
                <md-table-head>Ukupno</md-table-head>
              </md-table-row>
              <md-table-row v-for="kind, kindKey in $store.state.kindsMapper">
                <md-table-cell><strong>{{ kind }}</strong></md-table-cell>
                <md-table-cell v-for="status, statusKey in statuses">
                  {{ $store.state.selectedObject['status|kind'][`${statusKey}|${kindKey}`] }}
                </md-table-cell>
                <md-table-cell>{{ $store.state.selectedObject.kind[kindKey] }}</md-table-cell>
              </md-table-row>
              <md-table-row class="last-row">
                <md-table-cell><strong>Ukupno</strong></md-table-cell>
                <md-table-cell v-for="status, statusKey in statuses">{{ $store.state.selectedObject.status[statusKey] }}</md-table-cell>
                <md-table-cell>{{ $store.state.selectedObject.general }}</md-table-cell>
              </md-table-row>
            </md-table>
             <md-button class="md-primary md-dense md-raised print-btn" v-on:click="print($refs.reports)">
              Ispiši
            </md-button>
          </div>
        </md-dialog>
      </div>
      <div v-else class="error">
        <h3>Nažalost nema izvješća za prikaz</h3>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsMixin from '../../../mixins/reports-mixin';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'ReportsPlay',
  mixins: [FormatCurrency, ReportsMixin('getReportsPlay')],
  data(){
    return{
      reportVisible: false,
      selectedPerformance: {},
      statuses: {
        'offline_sold': 'Direktno',
        'online_checkout': 'Online rezervacija',
        'subscription': 'Pretplata',
        'unavailable': 'Izuzeto',
        'system_reserve': 'Sistemska',
        'reservation': 'Predrezervacija',
        'online_sold': 'Web',
        'subscription': 'Pretplate',
      }
    }
  },
  mounted(){
    let today = new Date().toLocaleDateString('hr-HR');
    this.title = `od ${today}
    do ${today}`
  },

  methods:{
    showReport(performance){
      this.selectedPerformance = JSON.parse(JSON.stringify(performance));
      this.$store.dispatch('getReportsPlay', performance.id);
      this.reportVisible = true;
    }
  }
}
</script>

<style lang="scss" scoped>
  .report-dialog{
    overflow: scroll;
    .print-wrapper{
      position: relative;
      padding: 35px 35px 100px;
    }
    .print-btn{
      position: absolute;
      right: 35px;
      bottom: 35px;
    }
    .md-title{
      span{
        display: block;
      }
    }

    .description{
      margin: 20px 0;
      td{
        padding: 6px 32px 6px 24px;
        font-size: 13px;
      }
    }
  }

  .filter-wrapper{
    display: flex;
    position: relative;
    max-width: 900px;

    .md-field{
      margin-right: 20px;
    }
  }

  .reports h2{
    text-align: center;
    margin: 50px 0;
    span{
      display: block;
    }

    .lighter{
      margin-top: 15px;
      font-size: 16px;
    }
  }

  .error{
    font-size: 22px;
    margin: 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }

  .single-table{
    margin-top: 75px;
    &:last-of-type{
      margin-bottom: 50px;
    }

    h3{
      margin-left: 20px;
    }
  }

  .reports-table{
    max-width: 900px;
		.md-table-cell, .md-table-head{
			&:not(:first-of-type){
				text-align: right;
			}
    }

    .md-table-cell{
      text-transform: capitalize;
    }

    .md-table-row:last-of-type{
      font-weight: bold;
    }
	}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/ReportsPlay.vue